import * as React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const ServicesToggleCategoryFilled = (props: SvgIconProps) => {
  return (
    <SvgIcon width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fill="currentColor"
        d="M20.25 12.03c.966 0 1.75.783 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5A1.75 1.75 0 0 1 16 16.28v-2.5c0-.967.784-1.75 1.75-1.75h2.5Zm-14 0c.966 0 1.75.783 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5A1.75 1.75 0 0 1 2 16.28v-2.5c0-.967.784-1.75 1.75-1.75h2.5Zm7 0c.966 0 1.75.783 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5A1.75 1.75 0 0 1 9 16.28v-2.5c0-.967.784-1.75 1.75-1.75h2.5Zm0-7c.966 0 1.75.783 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5A1.75 1.75 0 0 1 9 9.28v-2.5c0-.967.784-1.75 1.75-1.75h2.5Zm7 0c.966 0 1.75.783 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5A1.75 1.75 0 0 1 16 9.28v-2.5c0-.967.784-1.75 1.75-1.75h2.5Zm-14 0c.966 0 1.75.783 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5A1.75 1.75 0 0 1 2 9.28v-2.5a1.75 1.75 0 0 1 1.606-1.745l.144-.006h2.5Z"
      />
    </SvgIcon>
  );
};
